import React from 'react';

import { Alert as AntdAlert } from 'antd';

import { ConditionsReactivateVideoTutorielDto } from 'lib_api/lib/api/gen/api';

interface ConditionReactivateVideoProps {
  conditions?: ConditionsReactivateVideoTutorielDto;
}

function ConditionReactivateVideo({
  conditions,
}: ConditionReactivateVideoProps): React.ReactElement {
  const isInvalid: boolean =
    (conditions?.videoTutorielValid || conditions?.alreadyExist) ?? false;

  return (
    <>
      {isInvalid && (
        <AntdAlert
          type="warning"
          className="alertInvalid"
          message={
            <>
              {conditions?.videoTutorielValid && (
                <p className="alertInvalid--txt">La vidéo est déjà valide.</p>
              )}
              {conditions?.alreadyExist && (
                <p className="alertInvalid--txt">La vidéo existe déjà.</p>
              )}
            </>
          }
        />
      )}
    </>
  );
}

export default ConditionReactivateVideo;
